import api from "./api";
import { errorHandling } from "./error.handling";

const basePath = `${process.env.REACT_APP_API_CHIP_BASE_URL}/v1/chip`;

async function create(payload) {
  try {
    let response = await api.post(basePath, JSON.stringify(payload));
    let treated = errorHandling.handleResponse(response, "chipService.create");
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "chipService.create");
    return null;
  }
}

async function update(payload) {
  try {
    let response = await api.put(basePath, JSON.stringify(payload));
    let treated = errorHandling.handleResponse(response, "chipService.update");
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "chipService.update");
    return null;
  }
}

async function save(payload) {
  if (payload.id > 0) {
    payload.chipId = payload.id;
    await update(payload);
    return payload.id;
  }
  return await create(payload);
}

async function listMobileOperator() {
  try {
    const payload = {
      pageSize: 500,
      pageNumber: 1,
      mobileOperatorId: -1,
    };

    let response = await api.post(
      `${basePath}/MobileOperator`,
      JSON.stringify(payload)
    );
    let treated = errorHandling.handleResponse(
      response,
      "MobileOperatorService.listMobileOperator"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "MobileOperatorService.listMobileOperator");
    return null;
  }
}

async function listChipStatus() {
  try {
    const payload = {
      pageSize: 500,
      pageNumber: 1,
      statusChipId: -1,
    };

    let response = await api.post(
      `${basePath}/statusChip`,
      JSON.stringify(payload)
    );
    let treated = errorHandling.handleResponse(
      response,
      "MobileOperatorService.listChipStatus"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "MobileOperatorService.listChipStatus");
    return null;
  }
}

async function searchByLineNumber(lineNumber) {
  var payload = {
    pageSize: 500,
    pageNumber: 1,
    lineNumber: lineNumber,
  };

  try {
    let response = await api.post(`${basePath}/numberLine`, payload);
    let treated = errorHandling.handleResponse(
      response,
      "chipService.searchByLineNumber"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "chipService.searchByLineNumber");
    return null;
  }
}

async function searchByICCID(iccid) {
  var payload = {
    pageSize: 500,
    pageNumber: 1,
    lineNumber: iccid,
  };

  try {
    let response = await api.post(`${basePath}/numberLine`, payload);
    let treated = errorHandling.handleResponse(
      response,
      "chipService.searchByICCID"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "chipService.searchByICCID");
    return null;
  }
}

export const chipService = {
  save,
  searchByICCID,
  searchByLineNumber,
  listMobileOperator,
  listChipStatus,
};
